// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spin_wrapper_3HRzO","material-spinner":"Spin_material-spinner_3Xt4Z"};